import { useHomepageSection } from '@/hooks/useHomepageSection';
import { GALLERY_COPY } from '@/content/yawasCopy';

interface GalleryImage {
  src: string;
  alt: string;
}

const DEFAULT_IMAGES: GalleryImage[] = [
  { src: '/food/smash-burger-slider-v2.png', alt: 'Smash Burger mit Pommes – Yawas Kebab St. Gallen' },
  { src: '/food/smash-burger-hero.png', alt: 'Hausgemachter Smash Burger frisch vom Grill' },
  { src: '/food/smash-burger-classic.png', alt: 'Smash Burger mit karamelisierten Zwiebeln und Pommes' },
  { src: '/food/kebab.png', alt: 'Frisch zubereiteter Kebab – Yawas Kebab St. Gallen' },
  { src: '/food/kebab-durum.png', alt: 'Kebab Dürüm auf dem Teller' },
  { src: '/food/pommes.jpg', alt: 'Knusprige Pommes – Yawas Kebab St. Gallen' },
];

const GallerySection = () => {
  const { data } = useHomepageSection('gallery');

  const title = data?.title?.trim() || GALLERY_COPY.title;
  const subtitle = data?.subtitle?.trim() || GALLERY_COPY.subtitle;

  let images: GalleryImage[] = DEFAULT_IMAGES;
  if (data?.extra_json) {
    try {
      const parsed = data.extra_json as GalleryImage[];
      if (Array.isArray(parsed) && parsed.length > 0 && parsed[0]?.src) {
        images = parsed;
      }
    } catch {
      images = DEFAULT_IMAGES;
    }
  }

  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <span className="text-amber-500 text-sm font-semibold tracking-widest uppercase">{subtitle}</span>
          <h2
            className="text-3xl md:text-5xl font-bold text-stone-900 mt-3"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            {title}
          </h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
          {images.map((img, i) => (
            <div key={`${img.src}-${i}`} className="overflow-hidden rounded-2xl">
              <div className="w-full h-52 md:h-64 overflow-hidden group">
                <img
                  src={img.src}
                  alt={img.alt}
                    className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default GallerySection;
